import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"

import { useAppTheme } from '../../Providers/ThemeContext/ThemeContext'
import { Close } from "@mui/icons-material"

const ConfirmModal = ({ titleText, TitleIcon, text, open, setOpen, cancelFunction, cancelText = "Cancelar", confirmFunction, confirmText = "Confirmar" }) => {
    const { theme } = useAppTheme()
    const color_white = theme.palette.one_primary.contrastText

    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            scroll={'paper'}
            PaperProps={{ sx: { backgroundColor: theme.palette.one_modal_backcolor } }}
            maxWidth='md'
        >
            <DialogTitle
                sx={{
                    background: theme.palette.one_bar_gradient,
                    color: color_white,
                    height: '41px',
                    padding: '5px 5px 15px 5px',
                    textAlign: 'center',
                    verticalAlign: 'center'
                }} >
                <Grid container xs={12} sx={{ margin: 0, padding: 0 }}>
                    {TitleIcon &&
                        <Grid xs={1} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <TitleIcon />
                        </Grid>
                    }
                    <Grid xs sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        {titleText}
                    </Grid>
                    <Grid xs={1} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Close sx={{ cursor: 'pointer', ':hover': { fontSize: '30px' } }} onClick={() => setOpen(false)} />
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent
                dividers={true}
                style={{
                    paddingTop: '15px'
                }}>
                {text}
            </DialogContent>
            <DialogActions>
                <Grid container xs={12} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                    <Button onClick={() => setOpen(false)} variant="contained" color="error" size="small">{cancelText}</Button>
                    <Button onClick={() => confirmFunction()} variant="contained" color="success" size="small">{confirmText}</Button>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}

export default ConfirmModal
